import styled from 'styled-components'
import LogoTmovParceiros from '../../../../shared/assets/images/logo_parceiros.svg'
import { Tokens } from '@tmov/design-system/theme/types'

const { colors } = Tokens.eixods

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`
export const Document = styled.div`
  max-width: 800px;
  width: 100%;
  max-height: 600px;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 32px;
  & h3 {
    color: ${colors.brand.secondary[100]};
  }
  & > div {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;
    text-align: center;
    gap: 24px;
    & h4 {
      color: ${colors.brand.secondary[100]};
      width: 100%;
    }
    & p {
      color: ${colors.neutral.grey[70]};
      max-width: 600px;
      margin: 0 auto;
      flex-wrap: wrap;
    }
  }
`

export const Header = styled.img.attrs({
  src: LogoTmovParceiros,
  alt: 'Logo tmov parceiros',
})`
  width: 360px;
  height: 60px;
  object-fit: cover;
  margin: 40px auto 0;
`
export const ContainerDoc = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-evenly;
`
export const Action = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 24px;
  button {
    width: 120px;
  }
`
